// extracted by css-extract-rspack-plugin
export default {"root":"root-1rj4d","standard":"standard-2H4cn","narrow":"narrow-1aSdQ","wide":"wide-2560n"};